export default "__VITE_ASSET__BqtbDm1R__"